import { OrgQueryParam } from "@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";

import { RESERVED_ORG_IDS } from "@/state/constants";
import { CustomerDomainOrg } from "@/state/types";

import { PERMISSION_LEVELS } from "../constants";

export function getOrgQueryParam(
    selectedDomainOrg: CustomerDomainOrg
): OrgQueryParam {
    switch (selectedDomainOrg.orgId) {
        case RESERVED_ORG_IDS.NO_ORG:
            return {};
        case RESERVED_ORG_IDS.OTHER_ORGS:
            return { permissionLevel: PERMISSION_LEVELS.NON_ADMIN };
        default:
            return {
                orgId: selectedDomainOrg.orgId,
                permissionLevel: PERMISSION_LEVELS.ADMIN
            };
    }
}
